module.exports = __webpack_public_path__ + "static/media/amc.32cb901c.png";